export default __webpack_public_path__ + "static/media/avatar.01d24d93.svg";